/* eslint-disable no-console */
import axios from 'axios';

const navitia = axios.create({
    baseURL: process.env.NAVITIA_API_ENDPOINT,
    timeout: 10000,
});

export default {
    /**
     * Instance de axios avec des paramètres par défaut.
     * @type {Object}
     */
    axios: navitia,
    /**
     * Fonction wrapper permettant de retourner l'objet de data de axios directement.
     * Utile dans le cas du asyncData.
     * @param  {Promise} request Axios Request
     * @return {Promise}         Promise qui resolve lorsque la Promise Axios resolve contenant
     *                           le data du retour axios.
     */
    throughData(request) {
        return new Promise((resolve, reject) => {
            request
                .then((res) => {
                    resolve(res.data);
                })
                .catch(reject);
        });
    },
    /**
     * Recherche des lieux (adresses) via l'API Navitia
     * @param  {string} address        Adresse à rechercher
     * @param  {Boolean} allowFailure  (optionnel) Permettre à la requête de faire une erreur
     *                                 sans afficher la page d'erreur
     * @return {Promise(array)}        Liste des lieux trouvés
     */
    getPlaces(address, allowFailure = false) {
        if (!address) {
            return Promise.resolve([]);
        }

        const request = this.axios.get('/coverage/default/places', {
            params: {
                q: address,
                type: ['address'],
            },
            continueOnFailure: !!allowFailure,
            showWarningOnFailure: !!allowFailure,
        });

        return new Promise((resolve, reject) => {
            request
                .then((res) => {
                    resolve(res.data.places || []);
                })
                .catch((error) => {
                    if (allowFailure) {
                        resolve([]);
                    } else {
                        reject(error);
                    }
                });
        });
    },

    /**
     * Calcule des itinéraires entre deux points via l'API Navitia
     * @param  {string} from           Point de départ
     * @param  {string} to             Point d'arrivée
     * @param  {Boolean} allowFailure  (optionnel) Permettre à la requête de faire une erreur
     *                                 sans afficher la page d'erreur
     * @return {Promise(array)}        Liste des itinéraires
     */
    getJourneys(from, to, allowFailure = false) {
        if (!from || !to) {
            return {
                error: 'from and to are required',
            };
        }

        const request = this.axios.get('/coverage/default/journeys', {
            params: {
                from,
                to,
            },
            continueOnFailure: !!allowFailure,
            showWarningOnFailure: !!allowFailure,
        });

        return new Promise((resolve, reject) => {
            request
                .then((res) => {
                    resolve(res.data.journeys || []);
                })
                .catch((error) => {
                    if (allowFailure) {
                        resolve([]);
                    } else {
                        reject(error);
                    }
                });
        });
    },
};
